import PropTypes from 'prop-types'
import React from 'react'
import ReactLinkify from 'react-linkify'
import styled from 'styled-components'
import { easeInOutTransition } from '~/components/CommonStyles'

import { light } from '../constants/theme'

const StyledLink = styled.a`
  text-decoration: underline;
  color: ${light.dark900};
  ${easeInOutTransition};
  &:hover {
    color: ${light.primaryHover};
  }
`

const Linkify = ({ children }) => {
  return (
    <ReactLinkify
      componentDecorator={(decoratedHref, decoratedText, key) => (
        <StyledLink target="blank" href={decoratedHref} key={key}>
          {decoratedText}
        </StyledLink>
      )}
    >
      {children}
    </ReactLinkify>
  )
}

Linkify.propTypes = {
  children: PropTypes.node,
}

export default Linkify
